import gsap, { Power2 } from 'gsap';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(SplitText);

import { GetBy } from '../_app/cuchillo/core/Element';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { Ease } from '../_app/cuchillo/utils/Ease';
import VScroll_Item from '../_app/cuchillo/scroll/VScroll_Item';

export class ScrollItem__BlockDefault extends VScroll_Item {
    imgs = [];
    // title = [];
    // texts = [];

    //==================================================================================================================
    //          CONSTRUCTOR
    //==================================================================================================================
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        this.setAnimations();

        this.onShow = () => {
            this.showFunction();
        };
        this.onHide = () => {
            this.hideFunction();
        };
        this.onMove = () => {
            this.moveFunction();
        };
    }

    setAnimations() {
        this.imgs = GetBy.selector('figure', this.item);
        gsap.set(this.imgs, { opacity: 0 });
    }

    showFunction() {
        let delay = 0;

        for (let i = 0; i < this.imgs.length; i++) {
            const item = this.imgs[i];
            gsap.to(item, {
                opacity: 1,
                duration: 1,
                delay: delay + i * 0.1,
                ease: Power2.easeOut
            });
        }

        // if (this.title.length > 0) {
        //     for (let i = 0; i < this.title.length; i++) {
        //         const title = this.title[i];
        //         gsap.to(title, {
        //             y: 0,
        //             delay: delay + i * .1,
        //             duration: 1.2,
        //             ease: Ease.EASE_CUCHILLO_IN_OUT
        //         });
        //     }
        //     delay += .3;
        // // }

        // if (this.texts.length > 0) {
        //     for (let i = 0; i < this.texts.length; i++) {
        //         const texts = this.texts[i];
        //         gsap.to(texts, {
        //             y: 0,
        //             delay: delay + i * .05,
        //             duration: 1.4,
        //             ease: Ease.EASE_CUCHILLO_IN_OUT
        //         });
        //     }
        // }
    }

    hideFunction() { }

    moveFunction() { }
}

Scroll._registerClass('BlockDefault', ScrollItem__BlockDefault);
